module.exports = __webpack_public_path__ + "static/media/victorVarela.37d8d163.jpg";